// extracted by mini-css-extract-plugin
export default {"header-content":"HeaderContent_header-content__JZK3Q","links":"HeaderContent_links__6cFYW"};